import PasswordField from './PasswordField.view';
export default PasswordField;
